export default "__VITE_ASSET__B9Q9Au4f__"